export class RingBuffer {
  // | beginIndex | 0 | 1 | ... | last | first | ... | length - 1 | endIndex |
  // |            |      new data      |          old data        |          |
  constructor(length) {
    this.beginIndex = -1;
    this.length = length;
    this.endIndex = this.length;
    this.insertDirection = "right"; // left | right   - from curr index
    this.buffer = [];
    this.buffer.length = this.length;
    this.firstIndex = this.endIndex;
    this.lastIndex = this.beginIndex;
    this.actualLength = 0;
  }

  reset() {
    this.insertDirection = "right";
    this.firstIndex = this.endIndex;
    this.lastIndex = this.beginIndex;
    this.actualLength = 0;
  }

  // data, direction: left | right
  addData(data, direction = null) {
    const insertDirection = direction == null || (direction != "left" && direction != "right") ? this.insertDirection : direction;
    let bufferIndex = this.firstIndex;
    switch (insertDirection) {
      case "left":
        if (this.lastIndex == this.beginIndex) {
          bufferIndex = this.lastIndex;
        } else {
          bufferIndex = this.lastIndex - 1;
        }
        if (bufferIndex == this.beginIndex || bufferIndex == this.endIndex) {
          bufferIndex = this.length - 1;
        }
        this.buffer[bufferIndex] = data;
        this.firstIndex = bufferIndex;
        if (this.lastIndex == this.beginIndex) {
          this.lastIndex = bufferIndex;
        } else if (this.lastIndex == this.firstIndex) {
          this.lastIndex--;
          if (this.lastIndex == this.beginIndex) {
            this.lastIndex = this.length - 1;
          }
        }
        break;
      case "right":
        if (this.lastIndex == this.endIndex) {
          bufferIndex = this.lastIndex;
        } else {
          bufferIndex = this.lastIndex + 1;
        }
        if (bufferIndex == this.beginIndex || bufferIndex == this.endIndex) {
          bufferIndex = 0;
        }
        this.buffer[bufferIndex] = data;
        this.lastIndex = bufferIndex;
        if (this.firstIndex == this.endIndex) {
          this.firstIndex = bufferIndex;
        } else if (this.lastIndex == this.firstIndex) {
          this.firstIndex++;
          if (this.firstIndex == this.endIndex) {
            this.firstIndex = 0;
          }
        }
        break;
    }
    if (this.lastIndex < this.firstIndex) {
      this.actualLength = this.lastIndex + 1 + (this.firstIndex == this.endIndex ? 0 : this.length - this.firstIndex);
    } else {
      this.actualLength = this.lastIndex - this.firstIndex + 1;
    }
  }

  // data: [], direction: left | right
  addDataArray(data, direction = null) {
    if (data.length == 0) {
      return;
    }
    const insertDirection = direction == null || (direction != "left" && direction != "right") ? this.insertDirection : direction;
    let startDataIndex = data.length - this.length;
    if (startDataIndex < 0) {
      startDataIndex = 0;
    }
    let bufferIndex = this.firstIndex;
    switch (insertDirection) {
      case "left":
        if (this.lastIndex == this.beginIndex) {
          bufferIndex = this.lastIndex;
        } else {
          bufferIndex = this.lastIndex - 1;
        }
        if (bufferIndex == this.beginIndex || bufferIndex == this.endIndex) {
          bufferIndex = this.length - 1;
        }
        for (let dataIndex = startDataIndex; dataIndex < data.length; dataIndex++) {
          this.buffer[bufferIndex] = data[dataIndex];
          this.firstIndex = bufferIndex;
          if (this.lastIndex == this.beginIndex) {
            this.lastIndex = bufferIndex;
          } else if (this.lastIndex == this.firstIndex) {
            this.lastIndex--;
            if (this.lastIndex == this.beginIndex) {
              this.lastIndex = this.length - 1;
            }
          }
          bufferIndex--;
          if (bufferIndex == this.beginIndex) {
            bufferIndex = this.length - 1;
          }
        }
        break;
      case "right":
        if (this.lastIndex == this.endIndex) {
          bufferIndex = this.lastIndex;
        } else {
          bufferIndex = this.lastIndex + 1;
        }
        if (bufferIndex == this.beginIndex || bufferIndex == this.endIndex) {
          bufferIndex = 0;
        }
        for (let dataIndex = startDataIndex; dataIndex < data.length; dataIndex++) {
          this.buffer[bufferIndex] = data[dataIndex];
          this.lastIndex = bufferIndex;
          if (this.firstIndex == this.endIndex) {
            this.firstIndex = bufferIndex;
          } else if (this.lastIndex == this.firstIndex) {
            this.firstIndex++;
            if (this.firstIndex == this.endIndex) {
              this.firstIndex = 0;
            }
          }
          bufferIndex++;
          if (bufferIndex == this.endIndex) {
            bufferIndex = 0;
          }
        }
        break;
    }
    if (this.lastIndex < this.firstIndex) {
      this.actualLength = this.lastIndex + 1 + (this.firstIndex == this.endIndex ? 0 : this.length - this.firstIndex);
    } else {
      this.actualLength = this.lastIndex - this.firstIndex + 1;
    }
  }

  getLastData(count, action) {
    const dataCount = count > this.actualLength ? this.actualLength : count;
    let startBufferIndex = this.lastIndex + 1 - dataCount;
    let hasTwoSection = false;
    if (startBufferIndex < 0) {
      startBufferIndex = this.length + startBufferIndex;
      hasTwoSection = true;
    }
    if (startBufferIndex < this.firstIndex) {
      startBufferIndex = this.firstIndex;
    }
    if (hasTwoSection) {
      for (let bufferIndex = startBufferIndex; bufferIndex < this.endIndex; bufferIndex++) {
        if (!action(this.buffer[bufferIndex], bufferIndex)) {
          return;
        }
      }
      for (let bufferIndex = 0; bufferIndex <= this.lastIndex; bufferIndex++) {
        if (!action(this.buffer[bufferIndex], bufferIndex)) {
          return;
        }
      }
    } else {
      for (let bufferIndex = startBufferIndex; bufferIndex <= this.lastIndex; bufferIndex++) {
        if (!action(this.buffer[bufferIndex], bufferIndex)) {
          return;
        }
      }
    }
  }
}
